// @flow

import React from 'react';

import ElapsedTime from 'app/components/general/ElapsedTime';
import {LazyTooltip} from 'app/components/general/LazyTooltip';

import {WebHookLogSerializedType} from 'sweet-types';

interface Props {
  log: WebHookLogSerializedType;
}

export const LogItem = ({log}: Props): JSX.Element => (
  <div className="row py-2 border-bottom no-gutters">
    <div className="col-auto" style={{minWidth: 50}}>
      <span className={`badge badge-${log.success ? 'info' : 'danger'}`}>
        {log.response.status}
      </span>
    </div>
    <div className="col text-truncate overflow-hidden">
      <div className="d-flex">
        <div className="font-weight-bold mr-2">{log.request.method}</div>
        <LazyTooltip tooltip={log.request.url}>
          <div className="text-truncate">{log.request.url}</div>
        </LazyTooltip>
      </div>
      <ElapsedTime
        timestamp={log.created_at}
        className="small text-secondary font-italic"
      />
    </div>
  </div>
);
